import React, { useState } from "react";
import { Button } from "react-md";
import { createEmptyVectorAnswerFormula } from "./VariablesTable";
import DrawVectorAnswerOption from "./DrawVectorAnswerOption";

import deleteIcon from '../../images/png/deleteIcon.png';
import rigtArrowIcon from '../../images/png/right-arrow.png';
import leftArrowIcon from '../../images/png/left-arrow.png';
import plus from '../../images/png/plus.png';
import {
  Card,
  CardText,
  CardTitle,
} from "react-md";
const VectorAnswers = ({ _vectorAnswers, onValueChange }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);

  const onAddVector = () => {
    const index = _vectorAnswers.length;
    onValueChange([..._vectorAnswers, createEmptyVectorAnswerFormula(index)]);
    setCurrentIndex(index);
    if (index >= 5) setStartIndex(index - 4); // Adjust start index if more than 5
  };

  const onVectorValueChange = (value, targetIndex) => {
    const updatedVectors = _vectorAnswers.map((vector, index) => 
      index === targetIndex ? value : vector
    );
    onValueChange(updatedVectors);
  };

  const onDelete = (index) => {
    const updatedVectors = [
      ..._vectorAnswers.slice(0, index),
      ..._vectorAnswers.slice(index + 1),
    ];
    onValueChange(updatedVectors);
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
  };

  const handleVectorClick = (index) => setCurrentIndex(index);

  const handleNext = () => {
    if (startIndex + 5 < _vectorAnswers.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  // Determine if pagination is needed
  const displayVectors = _vectorAnswers.slice(startIndex, startIndex + 5);

  return (
    <Card>
        <div style={{display:"flex"}}>

          <CardTitle
                title="Vector Answer Formula"
                subtitle="Add formula for a vector answer"
                className="variable-table-card-title"
              />
               <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px',marginTop: "20px",
         marginLeft: "20px" }}>


                {_vectorAnswers.length > 5 && startIndex > 0 && (
                  <Button
                    icon
                    onClick={handlePrevious}
                    style={{ margin: '0 10px' }}
                  >
                    <img src={leftArrowIcon} alt="Previous" style={{ width: 24, height: 24 }} />
                  </Button>
                )}
         </div>

          {/* Display up to 5 vector buttons */}
          {displayVectors.map((_, index) => {
            const actualIndex = startIndex + index; // Get the actual index in the array
            return (
              <div
                key={actualIndex}  
                style={{ position: 'relative', display: 'inline-block', margin: "0 5px" }}
              >
                {/* Vector Button */}
                <Button
                  flat
                  onClick={() => handleVectorClick(actualIndex)}
                  style={{
                    padding: '2px',
                    margin: '2px',
                    color: actualIndex === currentIndex ? 'white' : '#bb0000',
                    backgroundColor: actualIndex === currentIndex ? '#bb0000' : 'white',
                    marginTop: "20px"
                  }}
                >
                  Vector {actualIndex + 1}
                </Button>

                {/* Delete Icon */}
                <Button
                  icon
                  tooltipLabel="Delete"
                  style={{
                    position: 'absolute',
                    top: '0px',
                    right: '-14px',
                  }}
                  onClick={() => onDelete(actualIndex)}
                >
                  <img src={deleteIcon} alt="Delete" />
                </Button>
              </div>
            );
          })}

          {/* Add button */}
          <Button
            icon
            tooltipLabel="Add Vector"
            onClick={onAddVector}
            style={{ marginLeft: "10px", marginTop: "12px" }}
          >
            <img src={plus} alt="Add" />
          </Button>
          {_vectorAnswers.length > 5 && startIndex + 5 < _vectorAnswers.length && (
            <Button
              icon
              onClick={handleNext}
              style={{ marginLeft: "10px", marginTop: "12px" }}
            >
              <img src={rigtArrowIcon} alt="Next" style={{ width: 24, height: 24 }} />
            </Button>
          )}
        </div>
      <div  >


        {/* Display current vector's form */}
        {_vectorAnswers[currentIndex] && (
          <DrawVectorAnswerOption
            data={_vectorAnswers[currentIndex]}
            onValueChange={(value) => onVectorValueChange(value, currentIndex)}
          />
        )}
      </div>
    </Card>
  );
};

export default VectorAnswers;